import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@/i18n.ts';
import App from './App';
import '@/index.scss';
import { isSafari } from './utils/browser/platform';

/**
 * 浏览器兼容性处理
 *  - 自定义 SVG 光标在 Safari 高分屏中栅格化有问题，需要使用 image-set 来提供不同分辨率的光标图像
 *  - 为什么不为全部浏览器使用 image-set 呢？因为在 Firefox 中，使用 image-set 会加载 2x 未缩放的光标
 *  - Firefox 有个类似的 fixed bug 但在 cursor 上就是不 work： https://bugzilla.mozilla.org/show_bug.cgi?id=1705877
 *  - Safari 没有找到相关 issue 但实测确实存在这个问题。
 *  - 为了避免之后有其他浏览器兼容问题，为 :root 添加 className 来控制浏览器兼容是最简单的方案
 */
if (isSafari()) {
  document.documentElement.classList.add('is-safari');
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found, please check index.html');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);
